import { render, staticRenderFns } from "./AbsenceTable.vue?vue&type=template&id=2a307ed0&"
import script from "./AbsenceTable.vue?vue&type=script&lang=js&"
export * from "./AbsenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports